import { IntegrationsActions } from "./types";
export function setIntegrationConfig(config) {
    return {
        type: IntegrationsActions.SET_INTEGRATION_CONFIG,
        payload: config,
    };
}
export function clearIntegrationConfig(integrationKey) {
    return {
        type: IntegrationsActions.CLEAR_INTEGRATION_CONFIG,
        payload: integrationKey,
    };
}
export function integrationsEventQueryParamsFound(queryParams) {
    return {
        type: IntegrationsActions.INTEGRATIONS_EVENT_QUERY_PARAMS_FOUND,
        payload: queryParams,
    };
}
export function integrationsEventBuyerFieldsPosted(fieldData) {
    return {
        type: IntegrationsActions.INTEGRATIONS_EVENT_BUYER_FIELDS_POSTED,
        payload: fieldData,
    };
}
export function integrationsEventOrderPlaced(orderResult) {
    return {
        type: IntegrationsActions.INTEGRATIONS_EVENT_ORDER_PLACED,
        payload: orderResult,
    };
}
